import {
  ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE,
  ABBYCARE_TERMINOLOGY_CODES_BASE
} from 'fhir/constants'

export const CARE_PLAN_ACTIVITY_TASK_CODE_SYSTEM = `${ABBYCARE_TERMINOLOGY_CODES_BASE}/care-plan-activity-task`
export const CARE_PLAN_ACTIVITY_INTERVENTION_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/care-plan-activity-intervention`
export const CARE_PLAN_ACTIVITY_GOAL_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/care-plan-activity-goal`
export const CARE_PLAN_CERT_PERIOD_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/care-plan-cert-period`
export const CARE_PLAN_CARE_PERIOD_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/care-plan-care-period`
export const CARE_PLAN_ACUTE_PERIOD_EXTENSION_URL = `${ABBYCARE_FHIR_STRUCTURE_DEFINITION_BASE}/care-plan-acute-period`

export const CARE_PLAN_DISPLAY = {
  [CARE_PLAN_CERT_PERIOD_EXTENSION_URL]: 'Care Plan for Cert Period',
  [CARE_PLAN_CARE_PERIOD_EXTENSION_URL]: 'Care Plan for Care Period',
  [CARE_PLAN_ACUTE_PERIOD_EXTENSION_URL]: 'Care Plan for Acute Period'
}
